import { render, staticRenderFns } from "./ComixAlert.vue?vue&type=template&id=13904412&scoped=true&"
import script from "./ComixAlert.vue?vue&type=script&lang=js&"
export * from "./ComixAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComixAlert.vue?vue&type=style&index=0&id=13904412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13904412",
  null
  
)

export default component.exports